import { createStyles } from "@mantine/emotion";

export default createStyles ( {
	earningRoot: {
		padding       : "2rem",
		display       : "flex",
		flexDirection : "column",
		height        : "100%",
		borderRadius  : "inherit",
		gap           : "1rem"
	},
	title: {
		fontSize   : "1.6rem",
		fontWeight : "500"
	}
} );